import { CreateTemplateMessage, CreateTemplateMessageVariables } from './__generated__/CreateTemplateMessage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateTemplateMessage($input: CreateTemplateMessageInputV2!) {
    createTemplateMessage: createTemplateMessageV2(input: $input) {
      ... on TemplateMessageV2 {
        id
        isFeatured
        attribution
        categoryId
        created
        message {
          id
          characters
          text
        }
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateTemplateMessage = () =>
  useMutation<CreateTemplateMessage, CreateTemplateMessageVariables>(MUTATION)
